'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("TableBody", {
  root: react.css`
    ${styleMixins_reset.boxSizing};
    display: table-row-group;
  `
});
const TableBody = (props) => {
  return react.jsx("tbody", { css: Styles.root, "data-zds": true }, props.children);
};

exports.TableBody = TableBody;
//# sourceMappingURL=TableBody.cjs.js.map
